import classNames from 'classnames';
import React from 'react';

import styles from '../statics/styles/audio.rtlignore-scss';

interface Props {
  seconds: number;
}

const Duration: React.FC<Props> = ({ seconds }) => {
  return <time dateTime={`P${Math.round(seconds)}S`}>{format(seconds)}</time>;
};

function format(seconds: number) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}

function pad(string: number) {
  return ('0' + string).slice(-2);
}

interface AudioDurationProps {
  played: number;
  duration: number;
  isLoading?: boolean;
}
const AudioDuration: React.FC<AudioDurationProps> = ({ played, duration, isLoading }) => {
  return (
    <div className={classNames(styles.audioDuration, { [styles.isLoading]: isLoading })}>
      {isLoading ? '--:--' : <Duration seconds={played > 0 ? played * duration : duration} />}
    </div>
  );
};
export default AudioDuration;
